import truncate from 'lodash/truncate'
import React from 'react'

import { useSidebar } from '@/components/ui/sidebar'
import useAppSelector from '@/hooks/useAppSelector'
import { useIsMinWidthMd } from '@/hooks/useIsMinWidthMd'
import {
  selectCurrentCompany,
  selectCurrentGroup,
  selectCurrentNetwork,
  selectHasCompanyAccount,
  selectIsAuthenticatedClient,
  selectIsUpdatingContext,
} from '@/redux/slices/session'
import {
  SessionMetadataCompany,
  SessionMetadataGroup,
  SessionMetadataNetwork,
} from '@/types/responses/session-metadata'

const CompanyOrGroupName: React.FC = () => {
  const isAuthenticatedClient = useAppSelector(selectIsAuthenticatedClient)
  const currentGroup = useAppSelector(selectCurrentGroup)
  const currentCompany = useAppSelector(selectCurrentCompany)
  const currentNetwork = useAppSelector(selectCurrentNetwork)
  const hasCompanyAccount = useAppSelector(selectHasCompanyAccount)
  const isUpdatingContext = useAppSelector(selectIsUpdatingContext)
  const { state, isMobile } = useSidebar()
  const isMinWidthMd = useIsMinWidthMd()

  function renderCompanyOrGroupName(
    companyOrGroup:
      | SessionMetadataCompany
      | SessionMetadataGroup
      | SessionMetadataNetwork
      | null,
  ) {
    if (!companyOrGroup) {
      return ''
    }

    if (isUpdatingContext) {
      return '(Updating...)'
    }

    const isCompany = 'presentationName' in companyOrGroup

    const name = isCompany
      ? companyOrGroup.presentationName
      : companyOrGroup.name

    return truncateText(name)
  }

  function truncateText(text: string) {
    return truncate(text, {
      // Note these values have been carefully chosen to ensure the text never
      // overflows into a second line
      length: isMinWidthMd ? 18 : 50,
    })
  }

  return (
    <div className="flex items-center gap-2 font-light text-xs
      whitespace-nowrap">
      {renderCompanyOrGroupName(
        currentCompany || currentGroup || currentNetwork,
      )}

      {isAuthenticatedClient &&
        hasCompanyAccount &&
        !isMobile &&
        state === 'expanded' && <span>(Client)</span>}
    </div>
  )
}

export default CompanyOrGroupName
